import React, { useMemo } from "react";
import { useFormikContext, Field } from "formik";
import usePermissions from "hooks/usePermissions";
import { Row } from "common/components";
import { FormikSelect, FormikInput, FormikInputList } from "security-app/components/common/FormikComponents";
import { useGetCategories, useGetPriorities } from "security-app/hooks/useAssetsAPI";
function UserFormFields() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
  const { values, errors, touched } = useFormikContext();
  const { isPermitted } = usePermissions();
  const isFromSource = useMemo(() => !!(values == null ? void 0 : values.imported_from), [values]);
  const canEdit = isPermitted("asset:edit");
  const { categories } = useGetCategories();
  const categoryOptions = useMemo(
    () => categories.map((category) => ({
      value: category.category,
      label: category.category
    })),
    [categories]
  );
  const { priorities } = useGetPriorities();
  const priorityOptions = useMemo(
    () => [...priorities].sort((a, b) => b.priority - a.priority).map((priority) => ({
      value: priority.priority,
      label: priority.text
    })),
    [priorities]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "name",
      id: "name",
      type: "text",
      label: "Asset Name *",
      placeholder: "Asset Name",
      value: values.name,
      required: true,
      error: touched.name && errors.name ? errors.name : void 0,
      bsStyle: touched.name && errors.name ? "error" : null,
      disabled: !canEdit || isFromSource
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikSelect,
      name: "category",
      id: "category",
      placeholder: "Add or select a category",
      multi: true,
      allowCreate: true,
      label: "Categories",
      value: values.category,
      options: categoryOptions,
      maxMenuHeight: 200,
      menuPlacement: "top",
      disabled: !canEdit
    }
  ), /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikSelect,
      name: "priority",
      id: "priority",
      placeholder: "Select a priority",
      label: "Priority",
      value: values.priority,
      options: priorityOptions,
      maxMenuHeight: 200,
      menuPlacement: "top",
      disabled: !canEdit,
      clearable: false
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInputList,
      label: "User Names *",
      name: "details.usernames",
      id: "usernames",
      placeholder: "Enter all the usernames to map this asset to logs",
      isClearable: true,
      help: "Press Tab or Enter to accept the entered value",
      values: (_a = values.details) == null ? void 0 : _a.usernames,
      error: ((_b = touched.details) == null ? void 0 : _b.usernames) && ((_c = errors.details) == null ? void 0 : _c.usernames) ? (_d = errors.details) == null ? void 0 : _d.usernames : "",
      bsStyle: ((_e = touched.details) == null ? void 0 : _e.usernames) && ((_f = errors.details) == null ? void 0 : _f.usernames) ? "error" : null,
      isDisabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInputList,
      label: "User IDs",
      name: "details.user_ids",
      id: "user_ids",
      placeholder: "Enter all the User IDs to map this asset to logs",
      isClearable: true,
      help: "Press Tab or Enter to accept the entered value",
      values: (_g = values.details) == null ? void 0 : _g.user_ids,
      error: ((_h = touched.details) == null ? void 0 : _h.user_ids) && ((_i = errors.details) == null ? void 0 : _i.user_ids) ? (_j = errors.details) == null ? void 0 : _j.user_ids : "",
      bsStyle: ((_k = touched.details) == null ? void 0 : _k.user_ids) && ((_l = errors.details) == null ? void 0 : _l.user_ids) ? "error" : null,
      isDisabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInputList,
      label: "Email Addresses",
      name: "details.email_addresses",
      id: "email_addresses",
      placeholder: "Enter all the Emails to map this asset to logs",
      isClearable: true,
      help: "Press Tab or Enter to accept the entered value",
      values: (_m = values.details) == null ? void 0 : _m.email_addresses,
      error: ((_n = touched.details) == null ? void 0 : _n.email_addresses) && ((_o = errors.details) == null ? void 0 : _o.email_addresses) ? (_p = errors.details) == null ? void 0 : _p.email_addresses : "",
      bsStyle: ((_q = touched.details) == null ? void 0 : _q.email_addresses) && ((_r = errors.details) == null ? void 0 : _r.email_addresses) ? "error" : null,
      isDisabled: !canEdit
    }
  )), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.first_name",
      id: "first_name",
      type: "text",
      label: "First Name",
      placeholder: "User First Name",
      value: (_s = values.details) == null ? void 0 : _s.first_name,
      disabled: !canEdit
    }
  ), /* @__PURE__ */ React.createElement(
    Field,
    {
      component: FormikInput,
      name: "details.last_name",
      id: "last_name",
      type: "text",
      label: "Last Name",
      placeholder: "User Last Name",
      value: (_t = values.details) == null ? void 0 : _t.last_name,
      disabled: !canEdit
    }
  )));
}
export default UserFormFields;
